import { render, staticRenderFns } from "./MarkdownRenderer.vue?vue&type=template&id=dc214d62&scoped=true"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=js"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=js"
import style0 from "./MarkdownRenderer.vue?vue&type=style&index=0&id=dc214d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc214d62",
  null
  
)

export default component.exports